import './llm-model-list.scss';
import template from './llm-model-list.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-llm-connect-llm-model-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'displayName',
            sortDirection: 'ASC',
            limit: 25,
            providerFilter: null,
            providers: [],
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdlc_llm_model');
        },

        providerRepository() {
            return this.repositoryFactory.create('tdlc_llm_provider');
        },

        columns() {
            return [{
                property: 'displayName',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.columnDisplayName'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'model',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.columnModel'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'provider.prefix',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.columnProvider'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'active',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.columnActive'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'isFavorite',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.columnFavorite'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'createdAt',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.columnCreatedAt'),
                allowResize: true,
                sortable: true,
            }];
        },

        providerOptions() {
            return this.providers.map((provider) => ({
                value: provider.id,
                label: provider.prefix,
            }));
        },
    },

    mounted() {
        this.loadProviders();
        this.getList();
    },

    methods: {
        fullModelIdentifier(item) {
            if (!item || !item.model) {
                return '';
            }

            const prefix = item.provider ? item.provider.prefix : '';

            return prefix ? `${prefix}:${item.model}` : item.model;
        },

        onCopyModelIdentifier(item) {
            const identifier = this.fullModelIdentifier(item);

            if (!identifier) {
                return;
            }

            const onSuccess = () => {
                this.createNotificationSuccess({
                    message: this.$t(
                        'TopdataLlmConnectSW6.topdata-llm-connect-llm-model.copyModelIdentifierSuccess',
                        { identifier },
                    ),
                });
            };

            const onError = () => {
                this.createNotificationError({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.copyModelIdentifierError'),
                });
            };

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(identifier).then(onSuccess).catch(onError);

                return;
            }

            const textarea = document.createElement('textarea');
            textarea.value = identifier;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();

            try {
                if (document.execCommand('copy')) {
                    onSuccess();
                } else {
                    onError();
                }
            } catch (_error) {
                onError();
            } finally {
                document.body.removeChild(textarea);
            }
        },

        loadProviders() {
            this.providerRepository.search(new Criteria()).then((result) => {
                this.providers = result;
            });
        },

        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));
            criteria.addAssociation('provider');
            if (this.term) {
                criteria.setTerm(this.term);
            }
            if (this.providerFilter) {
                criteria.addFilter(Criteria.equals('providerId', this.providerFilter));
            }

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        onChangeProviderFilter(providerId) {
            this.providerFilter = providerId;
            this.page = 1;
            this.getList();
        },

        onToggleFavorite(item) {
            const newValue = !item.isFavorite;
            item.isFavorite = newValue;

            this.repository.save(item).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.favoriteSaved'),
                });
            }).catch(() => {
                item.isFavorite = !newValue;
                this.createNotificationError({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.favoriteError'),
                });
            });
        },
    },
});
